import { isSupportedLocale } from '@/config/i18n/locales';

/** Strips a leading locale segment (`/en/...` → `/...`) for menu active-state matching. */
export function normalizePathnameWithoutLocale(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  const maybeLocale = segments[0];

  if (maybeLocale && isSupportedLocale(maybeLocale)) {
    const rest = segments.slice(1).join('/');
    return rest ? `/${rest}` : '/';
  }

  return pathname;
}
